module.exports = __webpack_public_path__ + "static/media/Level3espanol.388cd1a1.svg";